// @ts-nocheck
import { useEffect, useState } from "react";
import { ApiRequester } from "./ApiRequest";
import { _ } from "../../../vendor";
import {ChartDataMapper, ChartDataObjMapper, filterGeneratorPieChart} from "../../utils/ChartDataHelperOld";
import t from "./t";

/**
 * All hooks return an array of three elements.
 * - value
 * - isComplete
 * - query
 */

const defChartData = { json: [] };

// Total number of bookings per month
const filterTotalBookingPerMonth: (data: any) => any = (data : any): any => {
  const valSum: (obj: any) => any = (obj: any): any => Object.values(obj).reduce((a:any, b: any): any => a + b);
  const prop: string = "bookingsPerBookingType";
  const elemKey: string = t("total_bookings");
  const newData: any = data.map((x:any): {[x: string]: any;date: any} => ({
    [elemKey]: _.isObject(x[prop]) ? valSum(x[prop]) : 0,
    date: x.date,
  }));
  return ChartDataMapper(elemKey)(newData);
};
// ... additional filter per usage
const filterBookingPerUsageTypePerMonth: (data: any) => any = ChartDataObjMapper(
  "bookingsPerBookingType"
);
// ... additional filter per membership (user email domain)
const filterBookingsPerMembershipPerMonth: (data: any) => any = ChartDataObjMapper(
  "bookingsPerMembership"
);
// Total km per month
const filterTotalDistancePerMonth: (data: any) => any = ChartDataMapper("completeDistance");
// Total number of Bookings per usage type
const filterBookingsPerUsageType: (data: any) => { json: any; keys: any } = filterGeneratorPieChart(
  "bookingsPerBookingType"
);
// Total number of Distance per usage type
const filterDistancesPerUsageType: (data: any) => { json: any; keys: any } = filterGeneratorPieChart(
  "distancesPerBookingType"
);
const filterUsersPerMembership: (data: any) => { json: any; keys: any } = filterGeneratorPieChart();
const filterBookingsPerMembership: (data: any) => { json: any; keys: any } = filterGeneratorPieChart();

const filterCo2SavingsToCarInKG: (data: any) => { json: any; keys: any } = filterGeneratorPieChart(
  "co2SavingsToCarInKG"
);

export const useSummary: () => [{
  totalBooking: any;
  totalDistance: any;
  distancePerBooking: any;
  distancePerBike: any;
  bookingsPerUsageType: { json: any[] };
  distancesPerUsageType: { json: any[] };
  co2SavingsToCarInKG: { json: any[] }
}, boolean, (value: (((prevState: undefined) => undefined) | undefined)) => void] = (): [{
  totalBooking: any;
  totalDistance: any;
  distancePerBooking: any;
  distancePerBike: any;
  bookingsPerUsageType: { json: any[] };
  distancesPerUsageType: { json: any[] };
  co2SavingsToCarInKG: { json: any[] }
}, boolean, (value: (((prevState: undefined) => undefined) | undefined)) => void] => {
  const [query, setQuery] = useState();
  const [isCompleted, setCompleted] = useState(false);
  const [totalBooking, setTotalBooking] = useState(null);
  const [totalDistance, setTotalDistance] = useState(null);
  const [distancePerBike, setDistancePerBike] = useState(null);
  const [distancePerBooking, setDistancePerBooking] = useState(null);
  const [bookingsPerUsageType, setBookingsPerUsageType] =
    useState(defChartData);
  const [distancesPerUsageType, setDistancesPerUsageType] =
    useState(defChartData);
  const [co2SavingsToCarInKG, setCo2SavingsToCarInKG] =
    useState(defChartData);

  useEffect(() => {
    if (query) {
      const fetchDataSummaryPerMonth: () => Promise<void> = async (): Promise<void> => {
        try{
          const response: any = await ApiRequester("/charts/getSummary")();
          const data: any = response.data;

          setBookingsPerUsageType(filterBookingsPerUsageType(data));
          setDistancesPerUsageType(filterDistancesPerUsageType(data));
          setCo2SavingsToCarInKG(filterCo2SavingsToCarInKG(data));

          const {
            completeOrderCount,
            completeDistance,
            distancePerBooking,
            distancePerBike,
          } = data;

          setTotalBooking(completeOrderCount);
          setTotalDistance(completeDistance);
          setDistancePerBooking(distancePerBooking);
          setDistancePerBike(distancePerBike);
        } catch (xc: any) {
          console.log("getSummary", xc);
        }
        setCompleted(true);
      };
      setCompleted(false);
      // @ts-ignore
      fetchDataSummaryPerMonth(query);
    }
  }, [query]);

  return [
    {
      totalBooking,
      totalDistance,
      distancePerBooking,
      distancePerBike,
      bookingsPerUsageType,
      distancesPerUsageType,
      co2SavingsToCarInKG
    },
    isCompleted,
    setQuery,
  ];
};

export const useSummaryForAPeriod: () => [{
  totalBooking: any;
  totalDistance: any;
  distancePerBooking: any;
  distancePerBike: any;
  bookingsPerUsageType: { json: any[] };
  distancesPerUsageType: { json: any[] };
  co2SavingsToCarInKG: { json: any[] };
  co2SavingsFromNorderstedtToLuebeck: any;
  co2SavingsToNorderstedt: any
}, boolean, (value: (((prevState: undefined) => undefined) | undefined)) => void] = (): [{
  totalBooking: any;
  totalDistance: any;
  distancePerBooking: any;
  distancePerBike: any;
  bookingsPerUsageType: { json: any[] };
  distancesPerUsageType: { json: any[] };
  co2SavingsToCarInKG: { json: any[] };
  co2SavingsFromNorderstedtToLuebeck: any;
  co2SavingsToNorderstedt: any
}, boolean, (value: (((prevState: undefined) => undefined) | undefined)) => void] => {
  const [query, setQuery] = useState();
  const [isCompleted, setCompleted] = useState(false);
  const [totalBooking, setTotalBooking] = useState(null);
  const [totalDistance, setTotalDistance] = useState(null);
  const [distancePerBike, setDistancePerBike] = useState(null);
  const [distancePerBooking, setDistancePerBooking] = useState(null);
  const [co2SavingsFromNorderstedtToLuebeck, setCo2SavingsToNorderstedtLuebeck] = useState(null);
  const [co2SavingsToNorderstedt, setCo2SavingsToShortDrivesNorderstedt] = useState(null);
  const [bookingsPerUsageType, setBookingsPerUsageType] =
    useState(defChartData);
  const [distancesPerUsageType, setDistancesPerUsageType] =
    useState(defChartData);
  const [co2SavingsToCarInKG, setCo2SavingsToCarInKG] =
    useState(defChartData);

  useEffect((): void => {
    if (query) {
      const fetchDataSummaryPerMonth: (filter: any) => Promise<void> = async (filter: any): Promise<void> => {
        /**
         * @type {{from: Date, to: Date}}
         */
        const { from, to }: any = filter;
        const payload: any = { from, to };
        try{
          const response: any = await ApiRequester("/charts/getSummaryForAPeriod", payload, "POST")();
          const data: any = response.data;

          setBookingsPerUsageType(filterBookingsPerUsageType(data));
          setDistancesPerUsageType(filterDistancesPerUsageType(data));
          setCo2SavingsToCarInKG(filterCo2SavingsToCarInKG(data));

          const {
            completeOrderCount,
            completeDistance,
            distancePerBooking,
            distancePerBike,
            co2SavingsToNorderstedtLuebeck,
            co2SavingsToShortDrivesNorderstedt
          } = data;

          setTotalBooking(completeOrderCount);
          setTotalDistance(completeDistance);
          setDistancePerBooking(distancePerBooking);
          setDistancePerBike(distancePerBike);
          setCo2SavingsToNorderstedtLuebeck(co2SavingsToNorderstedtLuebeck);
          setCo2SavingsToShortDrivesNorderstedt(co2SavingsToShortDrivesNorderstedt);
        } catch (xc: any) {
          console.log("getSummaryForAPeriod", xc);
        }
        setCompleted(true);
      };
      setCompleted(false);
      fetchDataSummaryPerMonth(query);
    }
  }, [query]);

  return [
    {
      totalBooking,
      totalDistance,
      distancePerBooking,
      distancePerBike,
      bookingsPerUsageType,
      distancesPerUsageType,
      co2SavingsToCarInKG,
      co2SavingsFromNorderstedtToLuebeck,
      co2SavingsToNorderstedt
    },
    isCompleted,
    setQuery,
  ];
};

export const useSummaryPerMonth: () => [{
  totalBooking: { json: any[] };
  bookingsPerUsageType: { json: any[] };
  bookingsPerMembership: { json: any[] };
  totalDistance: { json: any[] }
}, boolean, (value: (((prevState: undefined) => undefined) | undefined)) => void] = () : [{
  totalBooking: { json: any[] };
  bookingsPerUsageType: { json: any[] };
  bookingsPerMembership: { json: any[] };
  totalDistance: { json: any[] }
}, boolean, (value: (((prevState: undefined) => undefined) | undefined)) => void] => {
  const [query, setQuery] = useState();
  const [isCompleted, setCompleted] = useState(false);
  const [totalBooking, setTotalBooking] = useState(defChartData);
  const [bookingsPerUsageType, setBookingsPerUsageType] =
    useState(defChartData);
  const [bookingsPerMembership, setBookingsPerMembership] =
    useState(defChartData);
  const [totalDistance, setTotalDistance] = useState(defChartData);

  useEffect((): void => {
    if (query) {
      const fetchDataSummaryPerMonth: (filter: any) => Promise<void> = async (filter: any): Promise<void> => {
        /**
         * @type {{from: Date, to: Date}}
         */
        const { from, to } = filter;
        const fy: any = from.getFullYear();
        const ty: any = to.getFullYear();
        const allYears: any = _.range(fy, ty + 1).map((year:number) =>
          ApiRequester(`/charts/getSummaryPerMonthYear/${year}`)()
        );
        // @ts-ignore
        try {
          const response: any = await Promise.allSettled(allYears);
          const data:any = response.map((x: any) => x.value.data).flat();

          setTotalBooking(filterTotalBookingPerMonth(data));
          setBookingsPerUsageType(filterBookingPerUsageTypePerMonth(data));
          setBookingsPerMembership(filterBookingsPerMembershipPerMonth(data));
          setTotalDistance(filterTotalDistancePerMonth(data));
        } catch (xc: any) {
          console.log("getSummaryPerMonthYear", xc);
        }

        setCompleted(true);
      };
      setCompleted(false);
      fetchDataSummaryPerMonth(query);
    }
  }, [query]);

  return [
    {
      totalBooking,
      bookingsPerUsageType,
      bookingsPerMembership,
      totalDistance,
    },
    isCompleted,
    setQuery,
  ];
};

export const useCountOfUsersPerMembership: () => [{
  json: any[]
}, boolean, (value: (((prevState: undefined) => undefined) | undefined)) => void] = () : [{
  json: any[]
}, boolean, (value: (((prevState: undefined) => undefined) | undefined)) => void] => {
  const [query, setQuery] = useState();
  const [isCompleted, setCompleted] = useState(false);
  const [usersPerMembership, setUsersPerMembership] = useState(defChartData);

  useEffect((): void => {
    if (query) {
      const fetchDataCountOfUsersPerMembership: () => Promise<void> = async () => {
        try {
          const response: any = await ApiRequester(
            "/charts/getCountOfUsersPerMembership"
          )();
          const data: any = response.data;

          setUsersPerMembership(filterUsersPerMembership(data));
        } catch (xc: any) {
          console.log("getCountOfUsersPerMembership", xc);
        }
        setCompleted(true);
      };
      setCompleted(false);
      // @ts-ignore
      fetchDataCountOfUsersPerMembership(query);
    }
  }, [query]);
  return [usersPerMembership, isCompleted, setQuery];
};

export const useCountOfBookingsPerMembership: () => [{
  json: any[]
}, boolean, (value: (((prevState: undefined) => undefined) | undefined)) => void] = (): [{
  json: any[]
}, boolean, (value: (((prevState: undefined) => undefined) | undefined)) => void] => {
  const [query, setQuery] = useState();
  const [isCompleted, setCompleted] = useState(false);
  const [bookingsPerMembership, setBookingsPerMembership] =
    useState(defChartData);

  useEffect((): void => {
    if (query) {
      const fetchDataCountOfBookingsPerMembership: () => Promise<void> = async (): Promise<void> => {
        try{
          const response: any = await ApiRequester(
            "/charts/getCountOfBookingsPerMembership"
          )();
          const data: any = response.data;

          setBookingsPerMembership(filterBookingsPerMembership(data));
        } catch (xc: any) {
          console.log("getCountOfBookingsPerMembership", xc);
        }
        setCompleted(true);
      };
      setCompleted(false);
      // @ts-ignore
      fetchDataCountOfBookingsPerMembership(query);
    }
  }, [query]);

  return [bookingsPerMembership, isCompleted, setQuery];
};
